import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import BaseButton from './Buttons3.js';

const Button = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (jsx(BaseButton, Object.assign({ type: "button" }, props, { children: children })));
};

export { Button as default };
